<section class="store-suggestions" *ngIf="suggestions.length" [attr.aria-label]="title">
  <h3 class="suggestions-title">{{ title }}</h3>
  <!-- One panel, the picks side by side, separated by a hairline (no box inside the box) -->
  <ul class="suggestions-list">
    <!-- each card wears its theme: the chips, the button and the hover take the theme's own colours -->
    <li class="suggestion" *ngFor="let suggestion of suggestions; trackBy: trackBySku"
        [style.--plugin-primary]="suggestion.product.designTokens?.primaryColor || null"
        [style.--plugin-secondary]="suggestion.product.designTokens?.secondaryColor || null">
      <!-- why it is here, in the theme's colour: "Complete your set", "Same mode: Dark", "Same category: Nature", "Same vibe: Mediterranean"... (owner, 2026-09-20) -->
      <span class="suggestion-reason">{{ suggestion.reason }}</span>
      <!-- the theme page opens in a new tab; the cart stays -->
      <a class="suggestion-identity" [routerLink]="'/theme'" [queryParams]="themeQuery(suggestion)" target="_blank" rel="noopener"
         [attr.aria-label]="suggestion.name + ' theme page (opens in a new tab)'">
        <img class="suggestion-logo" *ngIf="suggestion.product.logo" [src]="suggestion.product.logo" alt="" width="44" height="44"/>
        <span class="suggestion-text">
          <span class="suggestion-name">{{ suggestion.name }}</span>
          <span class="suggestion-platform" *ngIf="suggestion.platformName">
            <img *ngIf="suggestion.platformLogo" [src]="suggestion.platformLogo" alt="" class="suggestion-platform-logo"/>
            <span>for {{ suggestion.platformName }}</span>
          </span>
        </span>
      </a>
      <!-- the theme's three tags as soft chips in the theme's colour
           (owner, 2026-09-20: the tags only, no category / mode line, no colours) -->
      <span class="suggestion-tags" *ngIf="suggestion.tags.length">
        <span class="suggestion-tag" *ngFor="let tag of suggestion.tags">{{ tag }}</span>
      </span>
      <div class="suggestion-buy">
        <span class="suggestion-price">{{ priceLabel(suggestion) || '' }}</span>
        <button type="button" class="suggestion-add" (click)="add(suggestion)" [attr.aria-label]="'Add ' + suggestion.name + ' for ' + suggestion.platformName + ' to cart'">
          <app-icon name="plus" aria-hidden="true"></app-icon>
          <span>Add to cart</span>
        </button>
      </div>
    </li>
  </ul>
</section>
